import { Button } from '@/components/ui/button'

/**
 * An inline empty-state row for an employee table.
 *
 * Renders a single full-width `<tr>` (spanning `colSpan` columns) shown in a
 * table `tbody` when the current view has no rows while a search/filter is
 * active. It displays a message explaining that no employees match and a
 * "Clear" button (wired to `onClear`) that resets the active view.
 *
 * The consuming table decides when to render this row (i.e. when
 * `viewRows.length === 0 && isActive`).
 *
 * @param {Object} props
 * @param {number} props.colSpan - Number of columns the row should span.
 * @param {() => void} props.onClear - Clears search + filters.
 * @param {string} [props.message] - Override for the empty-state message.
 * @param {string} [props.className] - Extra classes for the `<td>` content wrapper.
 */
export default function EmptyState({
  colSpan,
  onClear,
  message = 'No employees match the current search and filters.',
  className,
}) {
  const tdClassName = ['py-6 text-center', className].filter(Boolean).join(' ')

  return (
    <tr>
      <td colSpan={colSpan} className={tdClassName}>
        <div className="flex flex-col items-center justify-center gap-2">
          <span className="text-sm text-muted-foreground">{message}</span>
          <Button type="button" variant="ghost" size="sm" className="h-7" onClick={onClear}>
            Clear
          </Button>
        </div>
      </td>
    </tr>
  )
}
